<template>
    <div class="contArea tpd">
      <term-service-view :terms="terms" :adTerms="adTerms"/>
      <button-apply before="/" @submit="validate"></button-apply>
    </div>
</template>


<script>
  import axios from "axios";
  import {api} from "../../../api";
  import ConstTerms from "../../../helpers/ConstTerms";
  import SubscApplyTermConst from "../SubscApply/SubscApplyTermConst";
  import TermServiceView from "../../Term/TermServiceView";
  import ButtonApply from "./ButtonSubscApply.vue";
  import PopupAlert from '../../../components/Popup/PopupAlert.vue';
  import PopupMsg from "../../../components/Popup/PopupMsgTemplate";

  export default {
    components: {
      TermServiceView,
      ButtonApply,
      PopupAlert,
      PopupMsg,
    },

    props: {solicitation: Object},

    data() {
      return {
        popupMsg: 'SUBSC_INFO',
        popupTitle: '',
        selected: [],
        terms: SubscApplyTermConst.TERMS,
        adTerms: SubscApplyTermConst.TERMS_AD_RECEIVE,
        errMsg: null,
      };
    },

    watch: {
      termMarketingChecked(v) { this.changeTermMarketingChecked(v); },
      termAdReceiveChecked(v) { this.changeTermAdReceiveChecked(v); },
      adTermsChecked(v) { this.changeAdTermsChecked(v); },
    },

    computed: {
      termMarketingChecked(){
        let term = this.terms.find((t)=> t.key === ConstTerms.MARKETING);
        return (term) ? term.checked : false;
      },

      termAdReceiveChecked(){
        let term = this.terms.find((t)=> t.key === ConstTerms.AD_RECEIVE_AGREE);
        return (term) ? term.checked : false;
      },

      adTermsChecked(){
        let term = this.adTerms.find((t)=> t.checked === true);
        return (term) ? term.checked : false;
      }
    },

    methods: {
      agree() {
        let terms = {
          "masking": true,
          "insurance": false,
          "marketing": false,
          "masking_chk": false,
          "ad_receive_app": false,
          "ad_receive_sms": false,
          "ad_receive_agree": false,
          "ad_receive_email": false,
          "insurance_survey": false,
          "service_agreement": false,
          "insurance_marketing": false,
          "personal_info_agree": false,
          "insurance_personal_info_agree": false
        }
        let hash = this.solicitation.hash;

        this.terms.forEach(term => { terms[term.key] = term.checked; });
        this.adTerms.forEach(term => { terms[term.key] = term.checked; });

        axios.post(
            api.subscSolicitations+'/'+hash+'/apply', {terms: terms}
        ).then((res)=>{
          let solicitation = res.data.data
          this.$emit('agreed', solicitation);
        }).catch((e)=>{
          if(e.response.msg){
            e.message = e.response.msg
          } else {
            e.message = '약관 동의중 오류가 발생하였습니다.'
          }
          this.$emit('error', e);
        })
      },

      validate() {
        for (let i in this.terms) {
          if (!(this.terms[i].checked || !this.terms[i].required)) {
            this.$emit('error', {message: 'NEED_SUBSC_TERM_CHECK'});
            return;
          }
        }

        if(this.termAdReceiveChecked) {
          let adReceive = this.adTerms.filter((adt)=>{ return adt.checked })
          if(adReceive.length === 0){
            this.$emit('error', {message: 'NEED_SUBSC_TERM_CHECK'});
            return;
          }
        }
        this.agree();
      },

      changeTermMarketingChecked(v) {
        if(!v) {
          let term = this.terms.find((t)=> t.key === ConstTerms.AD_RECEIVE_AGREE);
          if(term) term.checked = false;
        }
      },

      changeTermAdReceiveChecked(v){
        if(v) {
          
          let term = this.terms.find((t)=> t.key === ConstTerms.MARKETING);
          if(term) term.checked = true;

          if(!this.adTermsChecked)
            this.adTerms.forEach(adTerm => { adTerm.checked = true; });

        } else {
          this.adTerms.forEach(adTerm => { adTerm.checked = false; });
        }
      },

      changeAdTermsChecked(v){
        if(v) {
          let term = this.terms.find((t)=> t.key === ConstTerms.AD_RECEIVE_AGREE);
          if(term) term.checked = true;
        } 
      }
    },
  };
</script>

